/**
 * © [2023]  Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { useHistory, withRouter } from 'react-router-dom';
import ResearchExistingCMS64ReportTable from './ResearchExistingCMS64ReportTable';
import * as serviceEndPoint from '../../../../../../SharedModules/services/service';
import CustomSeparator from '../../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

import {
  RESEARCH_CMS64_HEAD,
  QUARTER_END_DATE_MAPPING,
} from '../utils/tableHead';

const ResearchExistingCMS64InvoiceAmount = ({ isInvovice = true }) => {
  const { quarter, rebateProgramCode, rebateProgramSelObj } = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.createCms64Data
  );
  const createCms64Data = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.createCms64Data
  );
  const responseCMSRpt = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.responseCMSRpt
  );
  const paymentsData = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.paymentsData
  );

  const [rebateQtr, setRebateQtr] = useState([]);
  useEffect(() => {
    const drugRebateQtr = calculateDrugRebateQuarter(quarter);
    setRebateQtr(drugRebateQtr);
  }, [quarter]);
  const history = useHistory();
  const convertQuarterToendDate = (qtr) => {
    const splitData = qtr.split('Q');
    const quater = `Q${splitData[0]}`;
    const year =
      splitData[0] == '4' ? parseInt(splitData[1]) + 1 : splitData[1];
    return `${QUARTER_END_DATE_MAPPING[quater]}${year}`;
  };

  const negativeValueConversion = (val) => {
    const num = parseFloat(val);
    if (isNaN(num)) {
      return '';
    }
    const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    const formattedNum = num.toLocaleString(undefined, options);
    return num < 0
      ? `($ ${Math.abs(num).toLocaleString(undefined, options)})`
      : `$ ${formattedNum}`;
  };

  const calculateDrugRebateQuarter = (startqtr) => {
    let calQtr = startqtr;
    const splitData = calQtr.split('Q');
    let strtQtrNum = parseInt(splitData[0]);
    let strtQtrYear = parseInt(splitData[1]);

    if (strtQtrNum == 1) {
      strtQtrNum = 4;
      strtQtrYear -= 1;
    } else {
      strtQtrNum -= 1;
    }
    calQtr = `${strtQtrNum}Q${strtQtrYear}`;

    return calQtr;
  };

  return (
    <>
      <div className='tabs-container'>
        <div className='tBillPanel custom-check'>
          <CustomSeparator
            parent1='System'
            parent2='Technical Window'
            parent3='Online Fixes'
            parent4='Research CMS 64 Inv Amts'
          />
          <div className='panel tBillPanel-space pb-0'>
            <div className='panel mb-3'>
              <div
                className='row'
                style={{ textAlign: 'center', marginLeft: '30%' }}
              />
              <div className='row'>
                <div style={{ width: '100%' }}>
                  <fieldset className='custom-fieldset'>
                    <legend
                      className='same-font-family'
                      style={{ color: '#274463' }}
                    >
                      MEDICAID DRUG REBATE SCHEDULE
                    </legend>
                    <div className='row'>
                      <div className='col-sm-4 mt-2'>
                        <div className='form-wrapper p-0 mt-2'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div>
                              <TextField
                                label='Rebate Program'
                                fullWidth
                                placeholder=''
                                InputLabelProps={{
                                  shrink: true,
                                  style: { color: '#274463' },
                                }}
                                name='rbtProg'
                                value={
                                  createCms64Data?.selectBy == 'single'
                                    ? createCms64Data?.rebateProgramCd
                                    : createCms64Data?.rebateProgramCdByCMS
                                }
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-sm-4 mt-2'>
                        <div className='form-wrapper p-0 mt-2'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div>
                              <TextField
                                label='Report Quarter'
                                fullWidth
                                placeholder=''
                                InputLabelProps={{
                                  shrink: true,
                                  style: { color: '#274463' },
                                }}
                                name='quarter'
                                value={quarter}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-sm-4 mt-2'>
                        <div className='form-wrapper p-0 mt-2'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div>
                              <TextField
                                label='State'
                                fullWidth
                                placeholder=''
                                InputLabelProps={{
                                  shrink: true,
                                  style: { color: '#274463' },
                                }}
                                name='quarter'
                                value='Maryland'
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-sm-4'>
                        <div className='form-wrapper p-0 mt-2'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div>
                              <TextField
                                label='Final Total'
                                className={
                                  paymentsData.InvAmountFinalTotal < 0
                                    ? 'txt-right negative-balance'
                                    : 'txt-right positive-balance'
                                }
                                fullWidth
                                placeholder=''
                                InputLabelProps={{
                                  shrink: true,
                                  style: { color: '#274463' },
                                }}
                                name='quarter'
                                value={`${negativeValueConversion(
                                  paymentsData.InvAmountFinalTotal
                                )}`}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-sm-4'>
                        <div className='form-wrapper p-0 mt-2'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div>
                              <TextField
                                label='Agency'
                                fullWidth
                                placeholder=''
                                InputLabelProps={{
                                  shrink: true,
                                  style: { color: '#274463' },
                                }}
                                name='agency'
                                value={rebateProgramSelObj[0]?.cms64AgencyName}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-sm-4'>
                        <div className='form-wrapper p-0 mt-2'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div>
                              <TextField
                                label='Quarter Ended'
                                fullWidth
                                placeholder=''
                                InputLabelProps={{
                                  shrink: true,
                                  style: { color: '#274463' },
                                }}
                                name='quarterended'
                                value={responseCMSRpt?.response?.data?.endDate}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {isInvovice && (
                        <>
                          <div className='col-sm-4'>
                            <div className='form-wrapper p-0 mt-2'>
                              <div className='mui-custom-form input-md field-xl'>
                                <div style={{ color: '#274463' }}>
                                  <b>
                                    <span
                                      style={{
                                        fontSize: '12px',
                                        fontWeight: '600',
                                      }}
                                    >
                                      Quarter Ending Date:{' '}
                                    </span>
                                  </b>
                                  <span
                                    style={{
                                      fontSize: '12px',
                                    }}
                                  >
                                    {responseCMSRpt?.response?.data?.endDate}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='col-sm-4'>
                            <div className='form-wrapper p-0 mt-2'>
                              <div className='mui-custom-form input-md field-xl'>
                                <div style={{ color: '#274463' }}>
                                  <b>
                                    <span
                                      style={{
                                        fontSize: '12px',
                                        fontWeight: '600',
                                      }}
                                    >
                                      Calendar Quarter:{' '}
                                    </span>
                                  </b>
                                  <span
                                    style={{
                                      fontSize: '12px',
                                    }}
                                  >
                                    {quarter}{' '}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='col-sm-4'>
                            <div className='form-wrapper p-0 mt-2'>
                              <div className='mui-custom-form input-md field-xl'>
                                <div style={{ color: '#274463' }}>
                                  <b>
                                    <span
                                      style={{
                                        fontSize: '12px',
                                        fontWeight: '600',
                                      }}
                                    >
                                      {' '}
                                      Drug Rebate Quarter:
                                    </span>
                                  </b>
                                  <span
                                    style={{
                                      fontSize: '12px',
                                    }}
                                  >
                                    {' '}
                                    {rebateQtr}{' '}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(ResearchExistingCMS64InvoiceAmount);
